module.exports = __webpack_public_path__ + "static/img/15041765451.71fe099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15041765451.jpg
// module id = 0zM0
// module chunks = 0